/**
 * Returns the Curacao states list to populate the select item.
 */
 export function gluky_addressfield_ni_states_list() {
    let temporalStates = [];
    const states =
    {
        '10' : 'Jinotega',
        '20' : 'Madriz',
        '25' : 'Esteli',
        '30' : 'Chinandega',
        '35' : 'Leon',
        '40' : 'Matagalpa',
        '45' : 'Nueva Segovia',
        '50' : 'Boaco',
        '55' : 'Managua',
        '60' : 'Masaya',
        '65' : 'Chontales',
        '70' : 'Granada',
        '75' : 'Carazo',
        '80' : 'Rivas',
        '85' : 'Rio San Juan',
        '91' : 'Region Autonoma Atlantico Norte',
        '93' : 'Region Autonoma Atlantico Sur',
    }
    
    Object.keys(states).map((res) => {
        temporalStates = [
        ...temporalStates,
        {
            name: states[res],
            code: res,
        },
        ];
    });
    return temporalStates;
    }
    
    /**
     * Returns the Curacao cities list by state code to populate the select item.
     *
     * @param $state_code
     *   The DANE state code
     * @return
     */
    export function gluky_addressfield_ni_cities_list($state_code) {
    let temporalCities = [];
    const $data = {
        '10':{
          '10050' : 'Wiwilí De Jinotega',
          '10100' : 'El Cuá',
          '10120' : 'San José De Bocay',
          '10150' : 'Santa María De Pantasma',
          '10200' : 'San Rafael Del Norte',
          '10250' : 'San Sebastián De Yalí',
          '10300' : 'La Concordia',
          '10350' : 'Jinotega',
        },
        '20':{
          '20050' : 'Somoto',
          '20100' : 'Totogalpa',
          '20150' : 'Telpaneca',
          '20200' : 'San Juan De Río Coco',
          '20250' : 'Palacagüina',
          '20300' : 'Yalagüina',
          '20350' : 'San Lucas',
          '20400' : 'Las Sabanas',
          '20450' : 'San José De Cusmapa',
        },
  
        '25':{
          '25050' : 'Pueblo Nuevo',
          '25100' : 'Condega',
          '25150' : 'Estelí',
          '25200' : 'San Juan De Limay',
          '25250' : 'La Trinidad',
          '25300' : 'San Nicolás',
        },
  
      ' 30':{
          '30050' : 'San Pedro Del Norte',
          '30100' : 'San Francisco Del Norte',
          '30150' : 'Cinco Pinos',
          '30200' : 'Santo Tomás Del Norte',
          '30250' : 'El Viejo',
          '30300' : 'Puerto Morazán',
          '30350' : 'Somotillo',
          '30400' : 'Villanueva',
          '30450' : 'Chinandega',
          '30500' : 'El Realejo',
          '30550' : 'Corinto',
          '30600' : 'Chichigalpa',
          '30650' : 'Posoltega',
        },
        '35':{
          '35050' : 'Achuapa',
          '35100' : 'El Sauce',
          '35150' : 'Santa Rosa Del Peñón',
          '35200' : 'El Jicaral',
          '35250' : 'Larreynaga',
          '35300' : 'Telica',
          '35350' : 'Quezalguaque',
          '35400' : 'León',
          '35450' : 'La Paz Centro',
          '35500' : 'Nagarote',
        },
        '40':{
          '40050' : 'Rancho Grande',
          '40100' : 'Rio Blanco',
          '40150' : 'El Tuma - La Dalia',
          '40200' : 'San Isidro',
          '40250' : 'Sébaco',
          '40300' : 'Matagalpa',
          '40350' : 'San Ramón',
          '40400' : 'Matiguás',
          '40450' : 'Muy Muy',
          '40500' : 'Esquipulas',
          '40550' : 'San Dionisio',
          '40600' : 'Terrabona',
          '40650' : 'Ciudad Darío',
        },
        '45':{
          '45050' : 'Jalapa',
          '45100' : 'Murra',
          '45150' : 'El Jícaro',
          '45200' : 'San Fernando',
          '45250' : 'Mozonte',
          '45300' : 'Dipilto',
          '45350' : 'Macuelizo',
          '45400' : 'Santa María',
          '45450' : 'Ocotal',
          '45500' : 'Ciudad Antigua',
          '45550' : 'Quilalí',
          '45600' : 'Wiwilí De Nueva Segovia',
        },
        '50':{
          '50050' : 'San José De Los Remates',
          '50100' : 'Boaco',
          '50150' : 'Camoapa',
          '50200' : 'Santa Lucía',
          '50250' : 'Teustepe',
          '50300' : 'San Lorenzo',
        },
        '55':{
          '55050' : 'San Francisco Libre',
          '55100' : 'Tipitapa',
          '55150' : 'Mateare',
          '55200' : 'Villa El Carmen',
          '55220' : 'Ciudad Sandino',
          '55250' : 'Managua',
          '55300' : 'Ticuantepe',
          '55320' : 'El Crucero',
          '55350' : 'San Rafael Del Sur',
        },
        '60':{
          '60050' : 'Nindirí',
          '60100' : 'Masaya',
          '60150' : 'Tisma',
          '60200' : 'La Concepción',
          '60250' : 'Masatepe',
          '60300' : 'Nandasmo',
          '60350' : 'Catarina',
          '60400' : 'San Juan De Oriente',
          '60450' : 'Niquinohomo',
        },
        '65':{
          '65050' : 'Comalapa',
          '65070' : 'San Francisco De Cuapa',
          '65100' : 'Juigalpa',
          '65150' : 'La Libertad',
          '65200' : 'Santo Domingo',
          '65250' : 'Santo Tomás',
          '65300' : 'San Pedro De Lóvago',
          '65350' : 'Acoyapa',
          '65400' : 'Villa Sandino',
          '65450' : 'El Coral',
        },
        '70':{
          '70050' : 'Diriá',
          '70100' : 'Diriomo',
          '70150' : 'Granada',
          '70200' : 'Nandaime',
        },
        '75':{
          '75050' : 'San Marcos',
          '75100' : 'Jinotepe',
          '75150' : 'Dolores',
          '75200' : 'Diriamba',
          '75250' : 'El Rosario',
          '75300' : 'La Paz De Carazo',
          '75350' : 'Santa Teresa',
          '75400' : 'La Conquista',
        }, 
        '80':{
          '80050' : 'Tola',
          '80100' : 'Belén',
          '80150' : 'Potosí',
          '80200' : 'Buenos Aires',
          '80250' : 'Moyogalpa',
          '80300' : 'Altagracia',
          '80350' : 'San Jorge',
          '80400' : 'Rivas',
          '80450' : 'San Juan Del Sur',
          '80500' : 'Cárdenas',
        },
        '85':{
          '85050' : 'Morrito',
          '85100' : 'El Almendro',
          '85150' : 'San Miguelito',
          '85200' : 'San Carlos',
          '85250' : 'El Castillo',
          '85300' : 'San Juan De Nicaragua',
        },
        '91':{
          '91050' : 'Waspán',
          '91100' : 'Puerto Cabezas',
          '91150' : 'Rosita',
          '91200' : 'Bonanza',
          '91250' : 'Waslala',
          '91270' : 'Mulukukú',
          '91300' : 'Siuna',
          '91350' : 'Prinzapolka',
        },
        '93':{ 
          '93050' : 'Paiwas',
          '93100' : 'La Cruz De Río Grande',
          '93120' : 'Desembocadura De Río Grande',
          '93150' : 'Laguna De Perlas',
          '93160' : 'El Tortuguero',
          '93200' : 'El Rama',
          '93230' : 'El Ayote',
          '93250' : 'Muelle De Los Bueyes',
          '93300' : 'Kukra-hill',
          '93350' : 'Corn Island',
          '93400' : 'Bluefields',
          '93450' : 'Nueva Guinea',
        },
    }
    const cities = $data[$state_code] ? $data[$state_code] : null;
    Object.keys(cities).map((citie) => {
        temporalCities = [
        ...temporalCities,
        {
            name: cities[citie],
            code: citie,
        },
        ];
    });
    return temporalCities;
}
    
    